<template>
  <div
    class="accordion__wrapper"
  >
    <div class="accordion__header">
      <button
        class="accordion__link"
        :aria-expanded="isActive()"
        @click="toggleActive"
      >
        <h3 class="accordion__title">
          {{ title }}
        </h3>
        <span
          class="accordion__toggle"
          :class="{active: isActive()}"
        >
          <img
            class="accordion__toggle-icon"
            :class="{'accordion__toggle-icon--active': isActive()}"
            src="/web/themes/custom/education_base/assets/images/icon-accordion-chevron.svg"
            alt=""
          >
          <img
            class="accordion__toggle-icon--hover"
            :class="{'accordion__toggle-icon--active': isActive()}"
            src="/web/themes/custom/education_base/assets/images/icon-accordion-chevron-blue.svg"
            alt=""
          >
        </span>
      </button>
    </div>
    <div
      class="accordion__content"
      :class="{'accordion__content--active': isActive()}"
      :aria-hidden="!isActive()"
    >
      <div class="accordion__content__inner">
        <slot />
        <br>
        <!-- Used line breaks instead of padding for smoother transition -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    simple: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    isActive() {
      return this.active;
    },
    toggleActive() {
      this.active = !this.active;
    },
  },
};
</script>
